import domain from './domain';

// Reset approved task deliverables
export const resetApprovedTaskDeliverables = domain.createEvent('resetApprovedTaskDeliverables');

// Reset task deliverable tree
export const resetTaskDeliverablesTree = domain.createEvent('resetTaskDeliverablesTree');
